import {Injectable} from '@angular/core';
import {DateTime} from "luxon";
import {BehaviorSubject} from "rxjs";
import {DataStore, SortDirection} from "@aws-amplify/datastore";
import {Bonus, BonusType, Contract, PermissionType, User} from "../../models";
import {APIService} from '../API.service';
import {ContractStatus} from "../enums/enums";

@Injectable({
    providedIn: 'root'
})
export class BonusServiceService {
    careers: Career[] = [
        {
            title: 'Excutive Advisor',
            amount: 5000,
            max: 10000,
            percent: 50,
        }, {
            title: 'Senior Advisor',
            amount: 10000,
            max: 30000,
            percent: 55,
        }, {
            title: 'Leader Advisor',
            amount: 30000,
            max: 60000,
            percent: 60,
        },
        {
            title: 'Excutive Manager',
            amount: 60000,
            max: 120000,
            percent: 65,
        }, {
            title: 'Senior Manager',
            amount: 120000,
            max: 250000,
            percent: 70,
        }, {
            title: 'Leader Manager',
            amount: 250000,
            max: 500000,
            percent: 75,
        }, {
            title: 'Excutive Director',
            amount: 500000,
            max: 750000,
            percent: 80,
        }, {
            title: 'Senior Director',
            amount: 750000,
            max: 1000000,
            percent: 85,
        }, {
            title: 'Leader Director',
            amount: 1000000,
            max: 100000000,
            percent: 90,
        },
    ];
    careerProgress: CareerProgress[] = [];

    years = [];
    quartrs: {
        '1': 'Gen - Mar',
        '2': 'Apr - Giu',
        '3': 'Lug - Set',
        '4': 'Ott - Dec',
    };
    allBonuses = []
    selectedYear: any;
    selectedMonth: string;
    public bonusLoaded = new BehaviorSubject<boolean>(false);
    bonusByDate = {}
    private career: Career;
    private currentYear: any;
    private currentQuarter: string;
    private currentMonth: string;
    selectedQuarter: string;
    private currentYearContracts: Contract[] = [];
    private userId: any;
    private SPONSOR_BONUS_5: any;
    private MANAGER_BONUS_6 = [];
    AMBASSADOR_BONUS_7 = 0;
    COMPANY_BONUS_8 = 0;
    DIRECTOR_BONUS_9 = 0;
    private total: any = [];


    constructor(private apiService: APIService) {
        this.setYearsAndMonths();
        this.bonusLoaded.subscribe(op => {
            //reloadBonus();
        });
    }


    async init(userId) {
        this.userId = userId;
        await this.setCarrer(userId);
        await this.setBonusVars();
        
        let allb = await DataStore.query(Bonus);
        this.currentYearContracts = await DataStore.query(Contract, condition => condition.startDate('contains', this.currentYear).status('eq', ContractStatus.ACTIVE));
        this.currentYearContracts = this.currentYearContracts.filter(x => x.commercial?.id == userId);
        let all = allb.filter(b => b.user?.id == userId);
        //  let all = await this.apiService.ListBonuses({userBonusId: {eq: userId}}, 1000);
        this.allBonuses = all;
        for await (let bonus of all) {
            let d = DateTime.fromISO(bonus.date);
            if (!d.isValid)
                continue;


            switch (bonus.typeEnum) {
                case BonusType.MARKETING_FEE_1:
                    if (!this.bonusByDate[BonusType.MARKETING_FEE_1][d.get("year")][d.get("month")])
                        this.bonusByDate[BonusType.MARKETING_FEE_1][d.get("year")][d.get("month")] = [];
                    this.bonusByDate[BonusType.MARKETING_FEE_1][d.get("year")][d.get("month")].push(bonus);
                    this.bonusByDate[BonusType.MARKETING_FEE_1][d.get("year")]["0"].push(bonus);
                    break;
                case BonusType.MANAGER_FEE_2:
                    if (!this.bonusByDate[BonusType.MANAGER_FEE_2][d.get("year")][d.get("month")])
                        this.bonusByDate[BonusType.MANAGER_FEE_2][d.get("year")][d.get("month")] = [];
                    this.bonusByDate[BonusType.MANAGER_FEE_2][d.get("year")][d.get("month")].push(bonus);
                    this.bonusByDate[BonusType.MANAGER_FEE_2][d.get("year")]["0"].push(bonus);
                    break;
                case BonusType.BONUS_TEAM_3:
                    if (!this.bonusByDate[BonusType.BONUS_TEAM_3][d.get("year")][d.get("month")])
                        this.bonusByDate[BonusType.BONUS_TEAM_3][d.get("year")][d.get("month")] = [];
                    this.bonusByDate[BonusType.BONUS_TEAM_3][d.get("year")][d.get("month")].push(bonus);
                    this.bonusByDate[BonusType.BONUS_TEAM_3][d.get("year")][0].push(bonus);
                    break;
                case BonusType.REVENUE_BONUS_4:
                    if (!this.bonusByDate[BonusType.REVENUE_BONUS_4][d.get("year")][d.get("quarter")])
                        this.bonusByDate[BonusType.REVENUE_BONUS_4][d.get("year")][d.get("quarter")] = [];
                    this.bonusByDate[BonusType.REVENUE_BONUS_4][d.get("year")][d.get("quarter")].push(bonus);
                    this.bonusByDate[BonusType.REVENUE_BONUS_4][d.get("year")][0].push(bonus);
                    break;
                case BonusType.SPONSOR_BONUS_5:
                    if (!this.bonusByDate[BonusType.SPONSOR_BONUS_5][d.get("year")][d.get("quarter")])
                        this.bonusByDate[BonusType.SPONSOR_BONUS_5][d.get("year")][d.get("quarter")] = [];
                    this.bonusByDate[BonusType.SPONSOR_BONUS_5][d.get("year")][d.get("quarter")].push(bonus);
                    this.bonusByDate[BonusType.SPONSOR_BONUS_5][d.get("year")]["0"].push(bonus);
                    break;
                case BonusType.MANAGER_BONUS_6:
                    if (!this.bonusByDate[BonusType.MANAGER_BONUS_6][d.get("year")][d.get("quarter")])
                        this.bonusByDate[BonusType.MANAGER_BONUS_6][d.get("year")][d.get("quarter")] = [];
                    this.bonusByDate[BonusType.MANAGER_BONUS_6][d.get("year")][d.get("quarter")].push(bonus);
                    this.bonusByDate[BonusType.MANAGER_BONUS_6][d.get("year")]["0"].push(bonus);
                    break;
                case BonusType.AMBASSADOR_BONUS_7:
                    if (!this.bonusByDate[BonusType.AMBASSADOR_BONUS_7][d.get("year")])
                        this.bonusByDate[BonusType.AMBASSADOR_BONUS_7][d.get("year")] = [];
                    this.bonusByDate[BonusType.AMBASSADOR_BONUS_7][d.get("year")].push(bonus);
                    break;
                case BonusType.COMPANY_BONUS_8:
                    if (!this.bonusByDate[BonusType.COMPANY_BONUS_8][d.get("year")])
                        this.bonusByDate[BonusType.COMPANY_BONUS_8][d.get("year")] = [];
                    this.bonusByDate[BonusType.COMPANY_BONUS_8][d.get("year")].push(bonus);
                    break;
                case BonusType.DIRECTOR_BONUS_9:
                    if (!this.bonusByDate[BonusType.DIRECTOR_BONUS_9][d.get("year")])
                        this.bonusByDate[BonusType.DIRECTOR_BONUS_9][d.get("year")] = [];
                    this.bonusByDate[BonusType.DIRECTOR_BONUS_9][d.get("year")].push(bonus);
                    break;
            }

        }

        await this.setCurrentAsyncBonus();
        
    }


    async setCarrer(userId) {
        let user = await DataStore.query(User, userId);
        let totalContarctsValue = user.totalActiveContracts;
        const c = [];
        for (const carrer of this.careers) {
            if (totalContarctsValue > carrer.amount && totalContarctsValue < carrer.max) {
                this.career = carrer;
                c.push({
                    career: carrer,
                    percent: Number((totalContarctsValue / carrer.max)).toFixed(2),

                });
            } else if (totalContarctsValue < carrer.amount) {
                c.push({
                    career: carrer,
                    percent: Number((totalContarctsValue / carrer.max)).toFixed(2),

                });
            } else {
                c.push({
                    career: carrer,
                    percent: 1,
                });
            }
        }
        this.careerProgress = c;
    }

    setYearsAndMonths() {
        let now = DateTime.now().get('year');

        while (now > 2019) {
            this.years.push(now);
            now = now - 1;
        }
        this.selectedYear = this.years[0];
        this.currentYear = this.years[0];
        this.selectedMonth = DateTime.now().get('month').toString();
        this.currentMonth = DateTime.now().get('month').toString();
        this.selectedQuarter = this.currentQuarter = DateTime.now().get('quarter').toString();
    }

    getFirstTotalValue(arr = []) {
        if (arr.length > 0) {
            return arr.reduce((n, {total}) => n + total, 0);
        } else {
            return 0;
        }
    }

    getBonus(type: BonusType): Bonus[] | any {

        switch (type) {
            case BonusType.MARKETING_FEE_1:
                return this.bonusByDate[type][this.selectedYear][this.selectedMonth] ?? [];
                break;
            case BonusType.MANAGER_FEE_2:
                return this.bonusByDate[type][this.selectedYear][this.selectedMonth] ?? [];
                break;
            case BonusType.BONUS_TEAM_3:
                if (this.currentMonth == this.selectedMonth && this.currentYear == this.selectedYear) {
                    let d = DateTime.now().set({month: parseInt(this.currentMonth)});
                    let startDate = d.startOf('month').toISODate();
                    let endDate = d.endOf('month').toISODate();
                    return this.calculate3TeamBonus(startDate, endDate);
                }

                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear][this.selectedMonth]);
                break;
            case BonusType.REVENUE_BONUS_4:
                if (this.currentQuarter == this.selectedQuarter && this.currentYear == this.selectedYear) {
                    let startQuarterMonth = (parseInt(this.currentQuarter) * 3) - 2;
                    let d = DateTime.now().set({month: startQuarterMonth, year: parseInt(this.currentYear)});
                    let startDate = d.startOf('month').toISODate();
                    let endDate = d.plus({month: 2}).endOf('month').toISODate();
                    
                    return this.calculate4RevenueBonus(startDate, endDate);
                }
                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear][this.selectedQuarter]);
                break;
            case BonusType.SPONSOR_BONUS_5:
                if (this.currentQuarter == this.selectedQuarter && this.currentYear == this.selectedYear) {
                    return this.SPONSOR_BONUS_5;
                }
                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear][this.selectedQuarter]);
                break;
            case BonusType.MANAGER_BONUS_6:
                if (this.currentQuarter == this.selectedQuarter && this.currentYear == this.selectedYear) {
                    return this.MANAGER_BONUS_6;
                }
                return this.bonusByDate[type][this.selectedYear][this.selectedQuarter] ?? [];
                break;
            case BonusType.AMBASSADOR_BONUS_7:
                if (this.currentYear == this.selectedYear) {
                    return this.AMBASSADOR_BONUS_7;
                }
                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear]);
                break;
            case BonusType.COMPANY_BONUS_8:
                if (this.currentYear == this.selectedYear) {
                    return this.COMPANY_BONUS_8;
                }
                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear]);
                break;

            case BonusType.DIRECTOR_BONUS_9:
                if (this.currentYear == this.selectedYear) {
                    return this.DIRECTOR_BONUS_9;
                }
                return this.getFirstTotalValue(this.bonusByDate[type][this.selectedYear]);
                break;
        }

    }

    private setBonusVars() {
        this.bonusByDate[BonusType.MARKETING_FEE_1] = [];
        this.bonusByDate[BonusType.MANAGER_FEE_2] = [];
        this.bonusByDate[BonusType.BONUS_TEAM_3] = [];
        this.bonusByDate[BonusType.REVENUE_BONUS_4] = [];
        this.bonusByDate[BonusType.SPONSOR_BONUS_5] = [];
        this.bonusByDate[BonusType.MANAGER_BONUS_6] = [];
        this.bonusByDate[BonusType.AMBASSADOR_BONUS_7] = [];
        this.bonusByDate[BonusType.COMPANY_BONUS_8] = [];
        this.bonusByDate[BonusType.DIRECTOR_BONUS_9] = [];
        for (const year of this.years) {
            this.bonusByDate[BonusType.MARKETING_FEE_1][year] = [];
            this.bonusByDate[BonusType.MANAGER_FEE_2][year] = [];
            this.bonusByDate[BonusType.BONUS_TEAM_3][year] = [];
            this.bonusByDate[BonusType.REVENUE_BONUS_4][year] = [];
            this.bonusByDate[BonusType.SPONSOR_BONUS_5][year] = [];
            this.bonusByDate[BonusType.MANAGER_BONUS_6][year] = [];
            this.bonusByDate[BonusType.AMBASSADOR_BONUS_7][year] = [];
            this.bonusByDate[BonusType.COMPANY_BONUS_8][year] = [];
            this.bonusByDate[BonusType.DIRECTOR_BONUS_9][year] = [];

            this.bonusByDate[BonusType.REVENUE_BONUS_4][year][0] = [];
            this.bonusByDate[BonusType.SPONSOR_BONUS_5][year][0] = [];
            this.bonusByDate[BonusType.MANAGER_BONUS_6][year][0] = [];

            for (let i = 0; i < 13; i++) {
                this.bonusByDate[BonusType.MARKETING_FEE_1][year][i] = [];
                this.bonusByDate[BonusType.MANAGER_FEE_2][year][i] = [];
                this.bonusByDate[BonusType.BONUS_TEAM_3][year][i] = [];
            }

            this.total[year] = 0;
        }


    }

    private calculate3TeamBonus(startDate, endDate) {
        let total = 0;
        let b = 0;

        let c = this.currentYearContracts.filter(x => {
            return x.startDate >= startDate && x.startDate <= endDate;
        });
        for (const contract of c) {
            total = total + contract.amount;
        }
        if (total <= 100000) {
            b = total / 100000;
        } else if (total > 100000 && total <= 200000) {
            b = (total * 0.5) / 100;

        } else if (total > 200000 && total <= 300000) {
            b = (total * 0.75) / 100;
        } else if (total > 300000 && total <= 400000) {
            b = (total * 1) / 100;
        } else if (total > 400000 && total <= 500000) {
            b = (total * 1.25) / 100;
        } else if (total > 500000) {
            b = (total * 1.5) / 100;
        }
        return b;
    }

    private calculate4RevenueBonus(startDate: string, endDate: string) {

        let total = 0;
        let b = 0;


        // eslint-disable-next-line @typescript-eslint/no-shadow
        let c = this.currentYearContracts.filter(x => {
            return x.startDate >= startDate && x.startDate <= endDate;
        });
        for (const contract of c) {
            total = total + contract.amount;
        }

        // @ts-ignore
        if (total >= 100000) {
            if (total >= 100000 && total < 200000) {
                b = (total * 0.5) / 100;

            } else if (total >= 200000 && total < 300000) {
                b = (total * 0.75) / 100;
            } else if (total >= 300000 && total < 400000) {
                b = (total * 1) / 100;
            } else if (total >= 400000 && total < 500000) {
                b = (total * 1.25) / 100;
            } else if (total >= 500000) {
                b = (total * 1.5) / 100;
            }
        } else {
            b = total / 100000;
        }
        return b;
    }

    private async calculate7AmbassadorBonus(startDate: string, endDate: string, userId) {
        let c = await DataStore.query(Contract, c => c.clientId('eq', userId).startDate('ge', startDate).startDate('le', endDate));
        let total = 0;
        let b = 0;
        c.forEach(x => {
            total = total + x.amount;
        });
        if (total <= 50000) {
            return 0;
        } else if (total > 50000 && total <= 100000) {
            b = (total * 1) / 100;

        } else if (total > 100000 && total <= 150000) {
            b = (total * 2) / 100;
        } else if (total > 150000 && total <= 200000) {
            b = (total * 3) / 100;
        } else if (total > 200000 && total <= 250000) {
            b = (total * 4) / 100;
        } else if (total >= 250000) {
            b = (total * 5) / 100;
        }
        return b;
    }

    private async calculate5Manageronus(startDate: string, endDate: string, userId) {
        const users = await DataStore.query(User,
            condition => condition.addedBy('eq', userId).permessions('ne', PermissionType.CLIENT),
        );
        let contracts = await DataStore.query(Contract, e => e.startDate('ge', startDate).startDate('le', endDate).status('eq', ContractStatus.ACTIVE));

        //  users = users.filter(u => u.userContractsAddedId == this.user.id);

        let b = 0;
        let usersTotal = [];
        let totals = [];
        for (const u of users) {
            let total = 0;
            const userContracts = contracts.filter(x => x.commercial?.id == u.id);
            // eslint-disable-next-line @typescript-eslint/no-shadow

            total = total + userContracts.reduce((n, {amount}) => n + amount, 0);
            totals.push(total);
            

        }
        let i = 0;
        let total = 0;
        totals = totals.sort((a, b) => a - b);
        for (let t of totals) {
            if (i >= 4)
                break;
            total = t + total;
            i = i + 1;
        }

        if (total < 100000) {
            b = total / 100000;
        } else if (total >= 100000 && total < 200000) {
            b = (total * 0.5) / 100;

        } else if (total >= 200000 && total < 300000) {
            b = (total * 0.75) / 100;
        } else if (total >= 300000 && total < 400000) {
            b = (total * 1) / 100;
        } else if (total >= 400000 && total < 500000) {
            b = (total * 1.25) / 100;
        } else if (total >= 500000) {
            b = (total * 1.5) / 100;
        }
        const userContracts = contracts.filter(x => x.commercial?.id == userId);

        
        let totalUserContract = userContracts.reduce((n, {amount}) => n + amount, 0);
        if (totalUserContract < 30000) {
            return 0;
        }

        return b;
    }

    async calculate6ManagerBonus(startDate: string, endDate: string, userId: any) {
        let contracts = await DataStore.query(Contract, condition => condition.startDate('ge', startDate).startDate('le', endDate).status('eq', ContractStatus.ACTIVE), {
            sort: s => s.startDate(SortDirection.ASCENDING)
        });
        let directUsers = await DataStore.query(User, u => u.addedBy('eq', userId));
        let payDate = DateTime.fromISO(endDate).plus({month: 3}).startOf('month').toISODate();
        let user = await DataStore.query(User, userId);
        let bonuses: Bonus[] = [];
        for (let directUser of directUsers) {
            const directuserContracts = contracts.filter(x => x.commercial?.id == directUser.id);
            let totalUserContract = directuserContracts.reduce((n, {amount}) => n + amount, 0);
            let oldTotalContracts = directUser.totalActiveContracts - totalUserContract;
            if (directUser.totalActiveContracts < 60000)
                continue;
            if (oldTotalContracts > 750000)
                continue;

            if (oldTotalContracts < 60000 && directUser.totalActiveContracts > 60000) {
                bonuses.push(new Bonus({
                    payDate: payDate,
                    user: user,
                    date: endDate,
                    total: 300,
                    info: directUser.lastname + ' ' + directUser.name + ' : Executive Manager',
                    type: BonusType.MANAGER_BONUS_6,
                    typeEnum: BonusType.MANAGER_BONUS_6
                }));

            } else if (oldTotalContracts < 120000 && directUser.totalActiveContracts > 120000) {

                bonuses.push(new Bonus({
                    user: user,
                    payDate: payDate,
                    date: endDate,
                    total: 400,
                    info: directUser.lastname + ' ' + directUser.name + ' : Senior Manager',
                    type: BonusType.MANAGER_BONUS_6,
                    typeEnum: BonusType.MANAGER_BONUS_6
                }));
            } else if (oldTotalContracts < 250000 && directUser.totalActiveContracts > 250000) {

                bonuses.push(new Bonus({
                    user: user,
                    payDate: payDate,
                    date: endDate,
                    total: 500,
                    info: directUser.lastname + ' ' + directUser.name + ' : Leader Manager',
                    type: BonusType.MANAGER_BONUS_6,
                    typeEnum: BonusType.MANAGER_BONUS_6
                }));
            }
            let downlineUsers = await DataStore.query(User, u => u.addedBy('eq', directUser.id));

            for (let downlineUser of downlineUsers) {
                const downlineuserContracts = contracts.filter(x => x.commercial?.id == downlineUser.id);
                let downlinetotalUserContract = downlineuserContracts.reduce((n, {amount}) => n + amount, 0);
                let downlineoldTotalContracts = downlineUser.totalActiveContracts - downlinetotalUserContract;
                if (downlineUser.totalActiveContracts < 60000)
                    continue;
                if (downlineoldTotalContracts > 750000)
                    continue;

                if (downlineoldTotalContracts < 60000 && downlineUser.totalActiveContracts > 60000) {
                    bonuses.push(new Bonus({
                        user: user,
                        payDate: payDate,
                        date: endDate,
                        total: 150,
                        info: downlineUser.lastname + ' ' + downlineUser.name + ' : Executive Manager',
                        type: BonusType.MANAGER_BONUS_6,
                        typeEnum: BonusType.MANAGER_BONUS_6
                    }));

                } else if (downlineoldTotalContracts < 120000 && downlineUser.totalActiveContracts > 120000) {

                    bonuses.push(new Bonus({
                        user: user,

                        payDate: payDate,
                        date: endDate,
                        total: 200,
                        info: downlineUser.lastname + ' ' + downlineUser.name + ' : Senior Manager',
                        type: BonusType.MANAGER_BONUS_6,
                        typeEnum: BonusType.MANAGER_BONUS_6
                    }));
                } else if (downlineoldTotalContracts < 250000 && downlineUser.totalActiveContracts > 250000) {

                    bonuses.push(new Bonus({
                        user: user,
                        payDate: payDate,
                        date: endDate,
                        total: 250,
                        info: downlineUser.lastname + ' ' + downlineUser.name + ' : Leader Manager',
                        type: BonusType.MANAGER_BONUS_6,
                        typeEnum: BonusType.MANAGER_BONUS_6
                    }));
                }
            }


        }
        return bonuses;
    }

    private async setCurrentAsyncBonus() {
        let startQuarterMonth = (parseInt(this.currentQuarter) * 3) - 2;
        let d = DateTime.now().set({month: startQuarterMonth, year: parseInt(this.currentYear)});
        let startDate = d.startOf('month').toISODate();
        let endDate = d.plus({month: 2}).endOf('month').toISODate();
        this.SPONSOR_BONUS_5 = await this.calculate5Manageronus(startDate, endDate, this.userId);

        this.MANAGER_BONUS_6 = await this.calculate6ManagerBonus(startDate, endDate, this.userId);

        let startYearDate = d.startOf('year').toISODate();
        let endYearDate = d.endOf('year').toISODate();
        this.AMBASSADOR_BONUS_7 = await this.calculate7AmbassadorBonus(startYearDate, endYearDate, this.userId);


        for (let year of this.years) {
            let cYear = await DataStore.query(Contract, p => p.startDate('contains', year).status('eq', ContractStatus.ACTIVE), {
                sort: s => s.startDate(SortDirection.ASCENDING)
            });
            cYear = cYear.filter(x => x.commercial?.id == this.userId);
            let total = cYear.reduce((n, {amount}) => n + amount, 0);
            this.total[year] = total;
        }
        
    }


    async calculateAllBonus(startDate, endDate, type: BonusType, userId): Promise<any> {
        let contracts = await DataStore.query(Contract, condition =>
            condition.startDate('ge', startDate).startDate('le', endDate).status('eq', ContractStatus.ACTIVE))
        switch (type) {
            case BonusType.BONUS_TEAM_3:
                let users3 = await DataStore.query(User, condition => condition.permessions('ne', PermissionType.CLIENT));
                let usersToGetBonus = [];
                for (let user of users3) {
                    let userContracts = contracts.filter(x => {
                        return x.commercial?.id == user.id && x.commercial.id != userId
                    });
                    let totaleUserContrcat = 0;
                    for (const contractOfUser of userContracts) {
                        totaleUserContrcat = totaleUserContrcat + contractOfUser.amount;
                    }
                    if (totaleUserContrcat > 10000)
                        usersToGetBonus.push({user: user, total: totaleUserContrcat});

                }
                if (usersToGetBonus.length == 0) {
                    return 0;
                }
                let totaleOtherUsers = 0;
                for (let userToGetB of usersToGetBonus) {
                    totaleOtherUsers = userToGetB.total;
                }


                let total3 = 0;
                let totalCurrentUser3 = 0;
                let b = 0;

                let c3 = contracts.filter(x => {
                    return x.commercial?.id == userId
                });

                for (const contract of c3) {
                    totalCurrentUser3 = totalCurrentUser3 + contract.amount;
                }
                
                total3 = totalCurrentUser3 + totaleOtherUsers;
                total3 = total3 / usersToGetBonus.length;
                if (total3 <= 10000) {
                    return 0;
                } else if (total3 > 10000 && total3 <= 20000) {
                    b = (totalCurrentUser3 * 0.5) / 100;

                } else if (total3 > 20000 && total3 <= 30000) {
                    b = (totalCurrentUser3 * 1) / 100;
                } else if (total3 > 30000) {
                    b = (totalCurrentUser3 * 1.5) / 100;
                }
                return b;
                break;
            case BonusType.REVENUE_BONUS_4:
                let total4 = 0
                let b4 = 0;
                let c = contracts.filter(x => {
                    return x.commercial?.id == userId;
                });
                for (const contract of c) {
                    total4 = total4 + contract.amount;
                }

                // @ts-ignore
                if (total4 >= 100000) {
                    if (total4 >= 100000 && total4 < 200000) {
                        b4 = (total4 * 1) / 100;

                    } else if (total4 >= 200000 && total4 < 300000) {
                        b4 = (total4 * 1.25) / 100;
                    } else if (total4 >= 300000 && total4 < 400000) {
                        b4 = (total4 * 1.5) / 100;
                    } else if (total4 >= 400000 && total4 < 500000) {
                        b4 = (total4 * 1.75) / 100;
                    } else if (total4 >= 500000) {
                        b4 = (total4 * 2) / 100;
                    }
                } else {
                    b4 = 0;
                }
                return b4;

                break;
            case BonusType.SPONSOR_BONUS_5:
                let b5 = await this.calculate5Manageronus(startDate, endDate, userId);
                return b5;
                break;
            case BonusType.MANAGER_BONUS_6:
                let bonuses6 = await this.calculate6ManagerBonus(startDate, endDate, userId);
                return bonuses6;
                break;

            case BonusType.AMBASSADOR_BONUS_7:
                let bonuses7 = await this.calculate7AmbassadorBonus(startDate, endDate, userId);
                return bonuses7;
                break;
        }
    }

    getTotalBonus() {

        return this.total[this.selectedYear]
    }
}

export type Career = {
    title: string;
    percent: number;
    max: number,
    amount: number;
};
export type CareerProgress = {
    career: Career,
    percent: number
};
